'use strict';

/**
 *
 * @name: nsCustomCssInjector
 *
 */

function NsCustomCssInjectorDirective() {

  'ngInject';

  return {
    restrict: 'A',
    scope: {
      post: '=nsPost'
    },
    link: function(scope) {

      var head = document.getElementsByTagName('head')[0];
      var styleNode = document.createElement('style');
      head.appendChild(styleNode);

      scope.$watch('post', function(newVal) {

        if (newVal && newVal.customCss) {

          styleNode.innerHTML = newVal.customCss;
        } else {

          styleNode.innerHTML = '';
        }
      });

      scope.$on('$destroy', function() {

        head.removeChild(styleNode);
      });
    }
  };
}

export default NsCustomCssInjectorDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-custom-css-injector.directive.js